/* global __APP_VERSION__ */

// 60초마다 확인
const VERSION_CHECK_INTERVAL = 300 * 1000;

let lastCheckedAt = 0;
let isChecking = false;
let isReloadPromptOpen = false;
let isAppVersionListenerInstalled = false;

const getLatestAppVersion = async () => {
  const response = await fetch(`/version.json?t=${Date.now()}`, {
    cache: 'no-store',
  });

  if (!response.ok) return null;
  if (!response.headers.get('content-type')?.includes('application/json')) return null;

  const data = await response.json();
  return typeof data.version === 'string' ? data.version : null;
};

export const checkAppVersionAndConfirmReload = async () => {
  if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_VERSION_CHECK !== 'true') return;
  if (isChecking || isReloadPromptOpen) return;

  const now = Date.now();
  if (now - lastCheckedAt < VERSION_CHECK_INTERVAL) return;

  isChecking = true;
  lastCheckedAt = now;

  try {
    const latestVersion = await getLatestAppVersion();
    if (!latestVersion || latestVersion === __APP_VERSION__) return;

    isReloadPromptOpen = true;
    const shouldReload = window.confirm(
      '새로운 버전이 배포되었습니다. 정상적인 서비스 이용을 위해 새로고침 후 최신 버전을 이용해주세요.\n\n지금 새로고침하시겠습니까?'
    );
    isReloadPromptOpen = false;

    if (shouldReload) window.location.reload();
  } catch {
    // 버전 확인 실패는 사용자 흐름을 막지 않습니다.
  } finally {
    isChecking = false;
    isReloadPromptOpen = false;
  }
};

export const installAppVersionCheckListeners = () => {
  if (isAppVersionListenerInstalled) return;
  isAppVersionListenerInstalled = true;

  window.addEventListener('focus', () => {
    checkAppVersionAndConfirmReload();
  });

  document.addEventListener('focusin', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;

    if (target.matches('input, textarea, select, [contenteditable="true"]')) {
      checkAppVersionAndConfirmReload();
    }
  });
};
